import React from "react";
 
import './App.css';
// import Home from './Component/Home';
// import Navbar from "./Component/Ui/Navbar";
// import Home from "./Component/Ui/Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Main from "./Component/Main";
import Navfoot from "./Component/Navfoot";
import AboutUs from "./Component/Pages/AboutUs";
import Tuitions from "./Component/Pages/Tuitions";
import CBSE from "./Component/Pages/CBSE";
import ICSE from "./Component/Pages/ICSE";
import Stateboard from "./Component/Pages/Stateboard";
import Neet from "./Component/Pages/EntranceExam/Neet";

function App() {
  return (
<BrowserRouter>
<Routes>
<Route path="/" element={<Navfoot/>} >
<Route index element={<Main />} />
<Route path="about-us" element={<AboutUs />}/>
<Route path="Tuitions" element={<Tuitions />}/>
<Route path="cbse"element={<CBSE />}/>
<Route path="icse"element={<ICSE />}/>
<Route path="Stateboard"element={<Stateboard />}/>
<Route path="NEET"element={<Neet/>}/>
</Route>
</Routes>
 </BrowserRouter>
  );
}
export default App;